document.addEventListener("DOMContentLoaded", function () {
  const counterSection = document.getElementById("counter-section");
  const counters = counterSection.querySelectorAll(".counter");

  const startCounting = () => {
    counters.forEach((counter) => {
      const target = +counter.getAttribute("data-count");
      let count = 0;

      // Reset to 0 before counting again
      counter.innerText = "0";

      const updateCount = () => {
        const increment = target / 50;
        count += increment;
        if (count < target) {
          counter.innerText = Math.ceil(count);
          setTimeout(updateCount, 50);
        } else {
          counter.innerText = target;
        }
      };

      updateCount();
    });
  };

  let hasAnimated = false;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!hasAnimated) {
            startCounting();
            hasAnimated = true;
          }
        }
        // } else {
        //   hasAnimated = false; // Reset flag when section leaves view
        // }
      });
    },
    {
      threshold: 0.5, // Run when 50% of section is visible
    }
  );

  observer.observe(counterSection);
});
